const readMetricsValues = {
  variable: ['$condition: MetricsCondition!, $duration: Duration!'],
  fragment: `
        readMetricsValues: readMetricsValues(condition: $condition, duration: $duration) {
          label
          values {
            values {value}
          }
          avg
          total
          perMin
        }`,
  fragmentAvgValue: `
        readMetricsValues: readMetricsValues(condition: $condition, duration: $duration) {
          avg
        }`
};

const readMetricsValue = {
  variable: ['$condition: MetricsCondition!, $duration: Duration!'],
  fragment: `readMetricsValue: readMetricsValue(condition: $condition, duration: $duration)`
};

function getStatusLabelFragmentValue(aggregatorType = 'avg') {
  return `
  readMetricsValues: readMetricsValues(condition: $condition, duration: $duration) {
    ${aggregatorType}
  }`
}

export default {
  readMetricsValues,
  readMetricsValue,
  getStatusLabelFragmentValue,
};
